import React, { useCallback, useState } from "react";
import { ChevronDown, MoreHorizontal } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { formatLawyerDisplayName } from "@admin/lib/lawyerDisplayName";

// Row actions collapsed into a dropdown. Purely presentational: children are
// the same action buttons with their own prompts, dialogs and API calls.
export function ActionsMenu({ lawyer, children }) {
  const [open, setOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const onDialogOpenChange = useCallback((o) => setDialogOpen(o), []);
  // While a child confirm dialog is up, clicks/focus inside it must not dismiss
  // (and unmount) the menu that owns that dialog.
  const guard = (e) => { if (dialogOpen) e.preventDefault(); };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={`actions-menu-${lawyer.id}`} aria-label={`Actions for ${formatLawyerDisplayName(lawyer.name, "lawyer")}`}
                className="inline-flex items-center gap-1 rounded-md border border-slate-200 bg-white px-2 py-1 text-xs font-bold text-[#0A2540] hover:border-[#0A2540] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37]">
          <MoreHorizontal size={12} aria-hidden="true" /> Actions <ChevronDown size={12} className="text-slate-400" aria-hidden="true" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-56 p-2" data-testid={`actions-popover-${lawyer.id}`}
                      onInteractOutside={guard} onFocusOutside={guard} onEscapeKeyDown={guard}>
        <div className="px-1 pb-2 text-[11px] font-bold uppercase tracking-wider text-slate-500">Actions</div>
        <div className="flex flex-col gap-1 [&>button]:w-full [&>button]:text-left [&>a]:w-full">
          {typeof children === "function" ? children({ onDialogOpenChange }) : children}
        </div>
      </PopoverContent>
    </Popover>
  );
}
